module.exports = __webpack_public_path__ + "img/Where-The-Road-Takes-Me.e82edbb3.jpg";